import React, { useState, useRef, useEffect } from 'react';
import styles from 'feature/common/landing/settings/index.module.scss';
import className from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import plate from 'images/landing/settings_plate.svg';
import creditCard from 'images/landing/settings_card.svg';
import { Button } from 'mochi-react-component';
import { devicePlateForm } from 'utils/device-util';
import useIntersect from 'utils/intersect-helper';
import amplitudeService from 'service/amplitude';

const Settings = () => {
  const cx = className.bind(styles);
  const { t } = useTranslation();
  const settingsRef = useRef();
  const [plateInfoshow, setPlateInfoShow] = useState(false);
  const [cardInfoShow, setCardInfoShow] = useState(false);

  const [setElement] = useIntersect(() => {
    setTimeout(() => {
      setPlateInfoShow(true);
    }, 0);
    setTimeout(() => {
      setCardInfoShow(true);
    }, 500);
  });

  useEffect(() => {
    setElement([settingsRef.current]);
  }, [setElement]);

  const plateInfoClass = cx({
    info: true,
    show: plateInfoshow,
  });

  const cardInfoClass = cx({
    info: true,
    show: cardInfoShow,
  });

  const fontSize = () => {
    return devicePlateForm() === 'desktop' ? `18px` : `16px`;
  };

  return (
    <section className={styles.settings} ref={settingsRef}>
      <h2>{t('landing.settings.title')}</h2>
      <h3>{t('landing.settings.message')}</h3>
      <div className={styles.content}>
        <div className={styles.block}>
          <div className={styles.image}>
            <img src={plate} alt="plate" loading="lazy" />
          </div>
          <div className={plateInfoClass}>
            <div className={styles.title}>{t('landing.settings.plate_number.title')}</div>
            <div className={styles.msg}>
              {t('landing.settings.plate_number.message')}
              <a href="https://help.mochipay.xyz/account-setting/member/plate-number">
                <Button
                  type="text"
                  theme="blue"
                  onClick={() => {
                    amplitudeService.track('服務介紹頁-如何設定車牌_點擊');
                  }}
                  customStyle={{ fontSize: fontSize() }}
                >
                  {t('landing.settings.plate_number.how_to_set_up')}
                </Button>
              </a>
            </div>
          </div>
        </div>
        <div className={styles.block}>
          <div className={styles.image}>
            <img src={creditCard} alt="credit-card" loading="lazy" />
          </div>
          <div className={cardInfoClass}>
            <div className={styles.title}>{t('landing.settings.credit_card.title')}</div>
            <div className={styles.msg}>
              {t('landing.settings.credit_card.message')}
              <a href="https://help.mochipay.xyz/account-setting/credit-card/setting-creditcard">
                <Button
                  type="text"
                  theme="blue"
                  onClick={() => {
                    amplitudeService.track('服務介紹頁-如何設定信用卡_點擊');
                  }}
                  customStyle={{ fontSize: fontSize() }}
                >
                  {t('landing.settings.credit_card.how_to_set_up')}
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Settings;
